.pageContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  height: 100vh;
}

.container {
  padding: 1rem 25px 0 25px;
  border-bottom: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  background: var(--static-background-standard, #fff);
}

.createListingsContainer {
  display: flex;
  gap: 1.5rem;
  min-width: 0;
  min-height: 30%;
  max-width: 100%;
  overflow: auto;
  padding: 2rem 2rem 0 2rem;
  background: var(--static-background-weak, #fafafa);
}

.styledCol {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 368px;
}